import classNames from 'classnames'

type Props = {
  currentIndex: number
  totalItems: number
}

const DotsIndicator = ({ currentIndex, totalItems }: Props) => {
  const dots = Array.from({ length: totalItems }, (_, index) => index)

  return (
    <div className="van-offer-dots-indicator" data-testid="van-offer-dots-indicator">
      {dots.map(index => (
        <div
          key={index}
          className={classNames('van-offer-dot', {
            'van-offer-dot--active': index === currentIndex,
          })}
          data-testid={`van-offer-dot-${index}`}
        />
      ))}
    </div>
  )
}

export default DotsIndicator
